module.exports = __webpack_public_path__ + "img/shangchuanba.8a61e27.svg";